// This file is used to define the schema for the file explorer forms
import { z } from 'zod';

export const folderSchema = z.object({
  name: z.string().min(1, { message: 'El nombre de la carpeta es requerido' }),
  description: z.string().optional(),
  parent: z.number().nullable(),
  remove_file_prefix: z.boolean(),
});

export type FolderSchema = z.infer<typeof folderSchema>;

export const editFolderSchema = folderSchema.omit({ parent: true });

export type EditFolderSchema = z.infer<typeof editFolderSchema>;

export const folderRenameSchema = z.object({
  name: z.string().min(1, { message: 'El nombre de la carpeta es requerido' }),
});

export type FolderRenameSchema = z.infer<typeof folderRenameSchema>;

export const renameFileSchema = z.object({
  title: z.string().min(1, 'El nombre es requerido'),
});

export type RenameFileSchema = z.infer<typeof renameFileSchema>;

export const uploadFileSchema = z.object({
  title: z.string().optional(),
  files: z.array(z.instanceof(File, { message: 'Selecciona al menos un archivo' })).min(1, 'Selecciona al menos un archivo'),
  description: z.string().optional(),
  category: z.number(),
}).refine((data) => {
  // If there is only one file, the title is required
  if (data.files.length === 1 && (!data.title || data.title.trim() === '')) {
    return false;
  }
  return true;
}, {
  message: 'El nombre es requerido para un solo archivo',
  path: ['title'],
}).refine((data) => {
  // If there is only one file, the description is required
  if (data.files.length === 1 && (!data.description || data.description.trim() === '')) {
    return false;
  }
  return true;
}, {
  message: 'La descripción es requerida',
  path: ['description'],
});

export type UploadFileSchema = z.infer<typeof uploadFileSchema>;

export const replaceFileSchema = z.object({
  file: z.instanceof(File, { message: 'Selecciona un archivo' }).optional(),
  title: z.string(),
  description: z.string().optional(),
});

export type ReplaceFileSchema = z.infer<typeof replaceFileSchema>;
